import { FC, ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Stack } from '@mui/material'
import { PHeader } from '../../components/Profile/PHeader'
import { AuthenticatedNotificationsBootstrap } from '../../components/Notifications/AuthenticatedNotificationsBootstrap'
import { AppContainer } from '../../components/ui-kit/AppContainer'
import { StyledBox, StyledContainer, PagesBox } from './style'

interface ProfileOnboardingLayoutProps {
  children?: ReactNode
}

/** Упрощённый лейаут: шапка как в кабинете, без сайдбара и нижней навигации. */
const ProfileOnboardingLayout: FC<ProfileOnboardingLayoutProps> = ({ children }) => {
  return (
    <AuthenticatedNotificationsBootstrap>
      <Box sx={StyledBox}>
        <PHeader />
        <Stack direction="row">
          <Box sx={PagesBox}>
            <AppContainer sx={StyledContainer}>
              {children || <Outlet />}
            </AppContainer>
          </Box>
        </Stack>
      </Box>
    </AuthenticatedNotificationsBootstrap>
  )
}

export default ProfileOnboardingLayout
